/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
// import { useToast } from "@/hooks/use-toast";
import { GenericType } from "@/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { z } from "zod";
import { default_permission } from "./default-permission";

type UseUserformType = {
  formData: GenericType;
  onFormSubmit: (prop: GenericType) => Promise<GenericType>;
  open: boolean;
  onOpenChange: (prop: boolean) => void;
};

const formSchema = z.object({
  role_name: z.string().min(1, {
    message: "Role name is required.",
  }),
  description: z.string().optional(),
  permission: z.any(),
});

export const mergeWithDefaultPermissions = (value: any[]): any[] => {
  const valueNames = new Set(value.map((item) => item.name));

  const missingItems = default_permission.filter(
    (defaultItem) => !valueNames.has(defaultItem.name),
  );

  return [...value, ...missingItems];
};

export const useReactForm = ({
  formData,
  onFormSubmit,
  onOpenChange,
}: // open,
UseUserformType) => {
  // const { toast } = useToast();
  const schemaKeys = formSchema.keyof().options;

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    mode: "onBlur",
    defaultValues: {
      role_name: "",
      description: "",
      permission: default_permission,
    },
  });

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      schemaKeys.forEach((key) => {
        if (formData[key]) {
          form.setValue(key, formData[key], {
            shouldTouch: true,
            shouldDirty: true,
          });
        }
        if (key === "permission") {
          const tempList = mergeWithDefaultPermissions(formData[key]);
          form.setValue(key, tempList, {
            shouldTouch: true,
            shouldDirty: true,
          });
        }
      });
    }
    console.log({ formData });
  }, [formData]);

  async function onSubmit(values: z.infer<typeof formSchema>) {
    const { data } = await onFormSubmit(values);

    if (data) {
      onOpenChange(false);
    }
  }

  return { form, onSubmit };
};
